import React, { useContext, useState } from 'react';
import { Select, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import SafetyCard from './SafetyCard';
import { ALERT_CATEGORY, triggerAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;
const { Option } = Select;

const VehicleDamageAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [damageLevel, setDamageLevel] = useState('None');
  const [loading, setLoading] = useState(false);

  const triggerDamageAlert = async () => {
    setLoading(true);
    await triggerAlert(
      { serialNo, vehicleKey, actual: damageLevel, threshold: '' },
      credentials,
      ALERT_CATEGORY.VEHICLE_DAMAGE_ALERT
    )
      .then(() => {
        messageApi.success(`Vehicle damage detected: ${damageLevel} damage`);
        onTriggered?.({ success: true, value: damageLevel });
      })
      .catch(() => {
        messageApi.error('Failed to report vehicle damage');
        onTriggered?.({ success: false, value: damageLevel });
      })
      .finally(() => setLoading(false));
  };

  const damageLevelColor = {
    'None': '#16a34a',
    'Minor': '#f59e0b',
    'Moderate': '#ef9400',
    'Severe': '#ef4444',
  };

  return (
    <SafetyCard
      title="Vehicle Damage"
      icon={<WarningOutlined />}
      iconBg="#fff5f5"
      iconColor="#ef4444"
      protectionLevel="Critical"
      onTrigger={triggerDamageAlert}
      triggerLabel="Report Damage"
      loading={loading}
    >
      <div>
        <Text style={{ fontSize: 11, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: 6 }}>
          Damage Level
        </Text>
        <Select value={damageLevel} onChange={setDamageLevel} style={{ width: '100%' }}>
          <Option value="None">None</Option>
          <Option value="Minor">Minor Damage</Option>
          <Option value="Moderate">Moderate Damage</Option>
          <Option value="Severe">Severe Damage</Option>
        </Select>
      </div>
      <div
        style={{
          padding: '10px 12px',
          borderRadius: 8,
          background: '#fff5f5',
          border: '1px solid #fca5a5',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: damageLevelColor[damageLevel], flexShrink: 0 }} />
        <Text style={{ fontSize: 11, color: '#dc2626', fontWeight: 500 }}>
          Triggered on impact or collision detection
        </Text>
      </div>
    </SafetyCard>
  );
};

export default VehicleDamageAlert;
